import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const Linkedin32: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(
      chroma === 'dark' ? s.svgLight24 : s.svgDark24,
      `svg-icon--${icon}`
    )}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    data-icon={getDataIconAttribute(chroma, icon, '32')}
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
  >
    <g>
      <path d="M 16.882812 15.214844 L 16.882812 15.171875 C 16.871094 15.1875 16.863281 15.199219 16.855469 15.214844 Z M 16.882812 15.214844 " />
      <path d="M 27.65625 2.621094 L 4.011719 2.621094 C 2.878906 2.621094 1.960938 3.515625 1.960938 4.621094 L 1.960938 28.542969 C 1.960938 29.648438 2.878906 30.542969 4.011719 30.542969 L 27.65625 30.542969 C 28.792969 30.542969 29.707031 29.648438 29.707031 28.542969 L 29.707031 4.621094 C 29.707031 3.515625 28.789062 2.621094 27.65625 2.621094 Z M 10.371094 25.996094 L 6.179688 25.996094 L 6.179688 13.386719 L 10.371094 13.386719 Z M 8.277344 11.664062 L 8.25 11.664062 C 6.84375 11.664062 5.933594 10.695312 5.933594 9.484375 C 5.933594 8.25 6.871094 7.308594 8.304688 7.308594 C 9.738281 7.308594 10.621094 8.25 10.648438 9.484375 C 10.648438 10.695312 9.738281 11.664062 8.277344 11.664062 Z M 25.484375 25.996094 L 21.292969 25.996094 L 21.292969 19.25 C 21.292969 17.554688 20.6875 16.398438 19.171875 16.398438 C 18.011719 16.398438 17.324219 17.175781 17.019531 17.929688 C 16.910156 18.199219 16.882812 18.574219 16.882812 18.953125 L 16.882812 25.996094 L 12.691406 25.996094 C 12.691406 25.996094 12.746094 14.566406 12.691406 13.386719 L 16.882812 13.386719 L 16.882812 15.171875 C 17.4375 14.3125 18.433594 13.089844 20.660156 13.089844 C 23.417969 13.089844 25.484375 14.890625 25.484375 18.765625 Z M 25.484375 25.996094 " />
    </g>
  </svg>
);

export default Linkedin32;
